
import {removeToken, setToken} from "@/utils/token"
import {getAccountInfo} from "@/api/login";
// import {login, changeAdminPassword, getAdminInfo, updateAdminInfo, currentUser} from "@/api/login";
// 处理路由
// roler:supermanager(超级管理员，暂时没做)/commanager（管理员admin）/storemanager（门店agent）
const state = {
    login: true, // 是否登录
    role: "students",// 路由权限相关信息 // admin（admin ）、special（judge）、students（team ）,admin_normal(admin)
    loginName:"", // 登录名称
    isSupperAdmin:false, // 是否是超级管理员
}
const getters = {
    getLoginState: (state) => state.login,// 获取登录状态
    getRole: (state) => state.role,// 获取用户信息
}
const mutations = {
    // 登录成功
    login: (state, payload) => {
        state.login = payload
    },
    // 后台的user对应前端的students
    userRole: (state, payload) => {
        state.isSupperAdmin = payload==="admin"
        if(payload==="user"){
            state.role = "students"
        }else if(payload==="admin" || payload==="admin_normal"){// admin超级管理员，admin_normal普通管理员
            state.role = "admin"
        }else if(payload==="judge"){
            state.role = "special"
        }else{
            state.role===""
        }
    },
    // 登录名称
    loginName: (state, payload) => {
        state.loginName = payload
    },
    loginOut: (state) => {
        state.login = false // 登出
        state.auth = ""
        state.loginName = ""
        removeToken() // 消除token
        window.location.reload()
    },
}
const actions = {
    loginOut(context) { // 退出
        context.commit("loginOut", true)
    },
//    获取当前账户信息
    async getUserInfo(context,data){
        const res = await getAccountInfo(data)
        if(res.err_code ===0){
           console.log(res)
        }
        return Promise.resolve(res)
    }

}
const modules = {}
export default {
    namespaced: true,
    state() {
        return state
    },
    getters,
    mutations,
    actions,
    modules
}

